(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("rp-analytics"));
	else if(typeof define === 'function' && define.amd)
		define(["rp-analytics"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("rp-analytics")) : factory(root["rp-analytics"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = initBookmakerRegPanel;

var _rpAnalytics = __webpack_require__(1);

var SegmentIO = _interopRequireWildcard(_rpAnalytics);

__webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function shuffleArray(items, seed) {
    var arr = [].concat(_toConsumableArray(items));
    var currentIndex = arr.length;
    var temporaryValue = void 0;
    var randomIndex = void 0;

    // The numbers 9301, 49297, and 233280 are part of a linear congruential generator (LCG),
    // A simple formula used to generate a sequence of pseudo-random numbers.
    var random = function random(max) {
        var newSeed = (seed * 9301 + 49297) % 233280;
        return Math.floor(newSeed / 233280 * max);
    };

    while (currentIndex !== 0) {
        randomIndex = random(currentIndex);
        currentIndex -= 1;
        temporaryValue = arr[currentIndex];
        arr[currentIndex] = arr[randomIndex];
        arr[randomIndex] = temporaryValue;
    }

    return arr;
}

function initBookmakerRegPanel() {
    var openedBookmakerClass = 'rh-bookmaker--open';
    var openedOverlayClass = 'rh-bookmakers__overlay--open';
    var openedOverlayHeaderClass = 'overlayWrap--open';
    var overlayActiveClass = 'activeDiscOffersOverlay';

    var isMobile = /iPhone|Android|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent);
    var isTabletBeakpoint = window.screen.width > 719;
    var selectedBreakpointUi = isTabletBeakpoint ? '.rh-bookmakers__list--tablet' : '.rh-bookmakers__list--mobile';

    // GET element after injecting
    var overlay = document.querySelector('.rh-bookmakers__overlay');
    var overlayHeader = document.querySelector('main .overlayWrap');
    var bookmakerListMobile = document.querySelector('.rh-bookmakers ' + selectedBreakpointUi);
    var webOffers = document.querySelectorAll('.rh-bookmakers__list--web');
    var tabletOffers = document.getElementsByClassName('rh-bookmakers__list rh-bookmakers__list--tablet');
    var mobileOffers = document.getElementsByClassName('rh-bookmakers__list rh-bookmakers__list--mobile');
    var offerLists = document.querySelectorAll('.rh-bookmakers__list');

    offerLists.forEach(function (unorderedList) {
        var listItems = Array.from(unorderedList.querySelectorAll('li'));

        var validTopOfferItems = listItems.filter(function (item) {
            return item.getAttribute('data-valid-topoffer') === 'true';
        });
        var shuffledValidTopOffers = shuffleArray(validTopOfferItems, new Date().getTime());

        var invalidTopOfferItems = listItems.filter(function (item) {
            return item.getAttribute('data-valid-topoffer') === 'false';
        });
        var shuffledInvalidTopOffers = shuffleArray(invalidTopOfferItems, new Date().getTime());

        // eslint-disable-next-line no-param-reassign
        unorderedList.innerHTML = '';

        [].concat(_toConsumableArray(shuffledValidTopOffers), _toConsumableArray(shuffledInvalidTopOffers)).forEach(function (item) {
            return unorderedList.appendChild(item);
        });
    });

    webOffers.forEach(function (desktopList) {
        desktopList.children[0].classList.add(openedBookmakerClass);

        // Once all bookmaker offers were shuffled,
        // then we need to add the position attribute to each offer
        desktopList.childNodes.forEach(function (bookmaker, index) {
            return bookmaker.setAttribute('bookmaker-position', index + 1);
        });
    });

    // Once all bookmaker offers were shuffled,
    // then we need to add the position attribute to each offer
    Array.from(tabletOffers).forEach(function (tabletList) {
        return tabletList.childNodes.forEach(function (bookmaker, index) {
            return bookmaker.setAttribute('bookmaker-position', index + 1);
        });
    });
    Array.from(mobileOffers).forEach(function (mobileList) {
        return mobileList.childNodes.forEach(function (bookmaker, index) {
            return bookmaker.setAttribute('bookmaker-position', index + 1);
        });
    });

    function closeOpenDiscOfferUi() {
        var openedBookmakerOffer = document.querySelector('.rh-bookmaker--open');

        overlay.classList.remove(openedOverlayClass);
        overlayHeader.classList.remove(openedOverlayHeaderClass);
        openedBookmakerOffer.classList.remove(openedBookmakerClass);
        bookmakerListMobile.classList.remove(overlayActiveClass);
    }

    if (isMobile) {
        Array.from(document.querySelectorAll('.rh-bookmakers__list--web')).forEach(function (webBookmakersNode) {
            return webBookmakersNode.remove();
        });
    }

    Array.from(document.querySelectorAll('main .rh-bookmakers ' + selectedBreakpointUi)).forEach(function (listNode) {
        return listNode.addEventListener('click', function (e) {
            if (e.target !== e.currentTarget) return;

            closeOpenDiscOfferUi();
        });
    });

    Array.from(document.querySelectorAll('main .overlayWrap')).forEach(function (listNode) {
        return listNode.addEventListener('click', function () {
            closeOpenDiscOfferUi();
        });
    });

    Array.from(document.querySelectorAll('.rh-bookmakers .rh-bookmaker__header')).forEach(function (headerNode) {
        return headerNode.addEventListener('click', function () {
            var _SegmentIO$trackOffer;

            var openedBookmakerNodes = document.getElementsByClassName(openedBookmakerClass);
            var bookmakerNode = headerNode.parentNode;
            var isWebPanel = headerNode.parentNode.parentNode.classList.contains('rh-bookmakers__list--web');
            var isBookmakerNodeOpened = bookmakerNode.classList.contains(openedBookmakerClass);
            var bookmakerPosition = Number(bookmakerNode.getAttribute('bookmaker-position'));
            // Bet365 comes with uppercase B, but it is required to be lowercase
            var bookmakerName = bookmakerNode.getAttribute('data-name') === 'Bet365' ? 'bet365' : bookmakerNode.getAttribute('data-name');
            var isOverlayOpened = overlay.classList.contains(openedOverlayClass);

            if (!isOverlayOpened && !isWebPanel) {
                overlay.classList.add(openedOverlayClass);
                bookmakerListMobile.classList.add(overlayActiveClass);
                overlayHeader.classList.add(openedOverlayHeaderClass);
            }

            if (openedBookmakerNodes.length > 0) {
                Array.from(openedBookmakerNodes).forEach(function (node) {
                    if (node === bookmakerNode) {
                        overlay.classList.remove(openedOverlayClass);
                        if (overlayHeader) {
                            overlayHeader.classList.remove(openedOverlayHeaderClass);
                        }
                        bookmakerNode.classList.remove(openedBookmakerClass);
                        bookmakerListMobile.classList.remove(overlayActiveClass);
                    } else {
                        node.classList.remove(openedBookmakerClass);
                    }
                });
            }

            if (!isBookmakerNodeOpened) {
                bookmakerNode.classList.add(openedBookmakerClass);
            }

            SegmentIO.trackOfferAccordion((_SegmentIO$trackOffer = {}, _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_OFFERS_BANNER, "Today's Offers"), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_POSITION, bookmakerPosition), _SegmentIO$trackOffer));
        });
    });

    Array.from(document.querySelectorAll('.rh-bookmaker-offer__claim-btn')).forEach(function (el) {
        return el.addEventListener('click', function () {
            var _SegmentIO$trackBookm;

            var bookmakerNode = el.parentNode.parentNode;
            var bookmakerName = bookmakerNode.getAttribute('data-name') === 'Bet365' ? 'bet365' : bookmakerNode.getAttribute('data-name');
            var bookmakerPosition = Number(bookmakerNode.getAttribute('bookmaker-position'));

            SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm = {}, _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_OFFERS_BANNER, "Today's Offers"), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_POSITION, bookmakerPosition), _SegmentIO$trackBookm));
        });
    });

    Array.from(document.querySelectorAll('.rh-bookmakers__sub-heading-allOffers')).forEach(function (el) {
        return el.addEventListener('click', function () {
            SegmentIO.trackAllOffers({});
        });
    });

    Array.from(document.querySelectorAll('.freeBets__Anchor')).forEach(function (el) {
        return el.addEventListener('click', function () {
            SegmentIO.trackFreeBetsTap({});
        });
    });
}

/***/ })
/******/ ]);
});
//# sourceMappingURL=rpbettingspecialoffer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rp-betting-special-offer/lib/rpbettingspecialoffer.js
// module id = 1935
// module chunks = 1